<template>
  <div :class="['form-group', customClass, { 'has-error': errorMessage, focus: isFocused, textarea: fieldType === 'textarea'}]">
    <label class="control-label" v-if="label" :for="inputId">
      <p class="control-label__text">{{ label }}</p>
      <span class="control-label__tooltip" v-if="tooltip.length > 0">
        <span class="control-label__tooltip-icon"></span>
        <p class="control-label__tooltip-msg">{{ tooltip }}</p>
      </span>
    </label>
    <div class="form-input-border">
      <textarea
        v-if="fieldType === 'textarea'"
        :type="type"
        :id="inputId"
        :value="modelValue"
        :placeholder="customPlaceholder ? '' : placeholder"
        :required="required"
        :maxlength="maxLength"
        :autocomplete="autocomplete"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="$emit('update:modelValue', $event.target.value)"
        @focus="handleFocus"
        @blur="handleBlurTextarea"
        :class="['form-input', inputClass]"
      />
      <input
        v-else
        :type="type"
        :id="inputId"
        :value="modelValue"
        :name="inputName"
        :placeholder="customPlaceholder ? ' ' : placeholder"
        :required="required"
        :maxlength="maxLength"
        :autocomplete="autocomplete"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="$emit('update:modelValue', $event.target.value)"
        @focus="handleFocus"
        @blur="handleBlur"
        :class="['form-input', inputClass]"
      />
      <span v-if="placeholder && !customPlaceholder" class="floating-label" v-html="placeholder"></span>
      <div class="input-placeholder" v-if="!modelValue && customPlaceholder" v-html="placeholder"></div>
    </div>
    <p v-if="errorMessage" class="help-block">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'InputGroup',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    fieldType: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    isFocusedProp: {
      type: Boolean,
      default: false  
    },
    customPlaceholder: {
      type: Boolean,
      default: false  
    },
    label: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    inputId: {
      type: [String, Number],
      default: null
    },
    errorMessage: {
      type: String,
      default: ''
    },
    customClass: {
      type: [String, Object, Array],
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputName: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFocused: this.isFocusedProp || false,
    };
  },
  methods: {
    handleFocus() {
      this.isFocused = true;
      this.$emit('focus', this.isFocused);
    },
    handleBlurTextarea() {
      this.isFocused = false;
    },
    handleBlur() {
      this.$emit('blur', this.modelValue);
      if (!this.modelValue) {
        this.isFocused = false;
      }
    }
  }
};
</script>
  
  <style scoped lang="scss">
  .form-group {
    display: flex;
    flex-direction: column;
    .input-placeholder {
        pointer-events: none;
        position: absolute;
        left: 0;
        top: 2px;
        overflow-x: hidden;
        height: 50px !important;
        padding-left: 56px !important;
        display: inline-block;
        font-family: "Roboto-Light";
        font-style: normal;
        font-size: 16px;
        line-height: 50px;
        color: #9ba1ab;
        user-select: none;

        b {
            font-weight: 100;
            font-family: "Roboto-Medium";
        }
    }
    &.has-error{
        .form-input-border{
            border: 1px solid #ff6161 !important;
        }
    }
    &.field-password{
        .form-input{
            transition: 0 !important;
        }
    }
    &.focus{
      &::before{
        opacity: 1;
      }
    }
    &.textarea{
      textarea{
        line-height: 24px;
        padding: 16px 20px;
        min-height: 150px;
        resize: none;
      }
      &.focus{
        .form-input-border{
          &::before,
          &::after{
            background-color: #414d60;
          }
        }
      }
      .form-input-border{
        position: relative;
        &::before{
          position: absolute;
          border-radius: 4px 4px 0 0;
          transition: 0.3s;
          content: '';
          left: 0;
          top: 0;
          width: 100%;
          background-color: #354051;
          height: 10px;
          -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(5%, black), to(transparent));
        }
        &::after{
          position: absolute;
          border-radius: 4px 4px 0 0;
          transition: 0.3s;
          content: '';
          bottom: 5px;
          transform: rotate(180deg);
          left: 0;
          width: 100%;
          background-color: #354051;
          height: 10px;
          -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(5%, black), to(transparent));
        }
      }
    }
    .control-label{
        display: flex;
        gap: 8px;
        align-items: center;
        margin-bottom: 5px;
        &__text{
          font-family: "Roboto-Light", sans-serif;
          font-weight: 400;
          font-size: 16px;
          line-height: 1.5;
          text-transform: uppercase;
          color: #f6f6f6;
          user-select: none;
        }
        &__tooltip{
          width: 16px;
          height: 16px;
          position: relative;
          cursor: pointer;
          &:hover{
            .control-label__tooltip-msg{
              opacity: 1;
              pointer-events: all;
            }
          }
          &-icon{
            width: 100%;
            height: 100%;
            //background: url("/webpack-assets/img/offer/info.svg") no-repeat center center;
            -webkit-background-size: contain;
            background-size: contain;
            display: inline-block;
          }
          &-msg{
            border-radius: 6px;
            font-family: "Roboto-Light";
            font-style: normal;
            font-size: 14px;
            line-height: 140%;
            text-align: left;
            opacity: 0;
            pointer-events: none;
            padding: 12px 15px;
            color: #F6F6F6;
            position: absolute;
            width: 260px;
            background: #414d60;
            transition: 0.3s;
            bottom: 32px;
            right: -7px;
            text-transform: none;
            letter-spacing: normal;
            z-index: 1;
            box-shadow: 0px 4px 15px 0px #00000040;
            &::after{
              content: "";
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 15px solid #414d60;
              border-bottom: 0;
              border-bottom: initial;
              position: absolute;
              bottom: -10px;
              height: 0;
              margin-left: 3px;
              width: 0;
              right: 5px;
            }
          }
        }
    }
    .form-input-border{
      border: 1px solid transparent !important;
      margin-bottom: 5px;
      border-radius: 4px;
      input:not(:placeholder-shown) + .input-placeholder {
        visibility: hidden;
      }
    }
    .form-input{
        font-size: 16px;
        font-family: "Roboto-Light";
        font-size: 16px;
        box-shadow: none;
        background-color: #354051 !important;
        line-height: 40px;
        height: 55px;
        border-radius: 4px;
        color: #f7f7f7;
        padding: 0 20px;
        width: 100%;
        transition: 0.3s all !important;
        border: 1px solid transparent;
        &[type=password]{
            font-family: 'Roboto-Light';
            &:not(:placeholder-shown){
              font-size: 18px !important;
              font-family: 'Roboto-Black' !important;
            }
          }
        &[type=password]::placeholder{
            color: #9BA1AB !important;
            font-size: 16px !important;
            font-family: 'Roboto-Light'!important;
        }
        &:focus{
            background-color: #414d60 !important;
        }
        &::placeholder{
            font-family: "Roboto-Light", sans-serif;
            font-weight: 400;
            font-size: 16px;
            line-height: 1.5;
            color: #9ba1ab;
        }
        &:-webkit-autofill,
        &:autofill {
          transition: 99999999999s all !important;
          background-color: #414d60 !important;
          box-shadow: 0 0 0px 1000px #414d60 inset !important;
          -webkit-text-fill-color: #f7f7f7 !important;
          border: 4px solid #414d60 !important;
          color: #F6F6F6 !important;
          padding: 0 17px;
        }
    }
    .help-block{
        font-family: "Roboto-Light", sans-serif;
        margin: 0;
        color: #ff6161;
        font-size: 12px;
    }
  } 
  </style>